{
  "version": 1,
  "asset_id": "a8055f2a-535c-4d94-ba3a-f4c8878b1bbe",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/a8055f2a-535c-4d94-ba3a-f4c8878b1bbe/loc-fort-worth-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/a8055f2a-535c-4d94-ba3a-f4c8878b1bbe/loc-fort-worth-640.avif",
  "original_filename": "loc-fort-worth-640.avif",
  "size": 17717,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:24Z"
}
